import http from "../utils/axiosInstance";

class albumDataService {
  create(data, token) {
    return http.post("/album", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  getById(id, token) {
    return http.get(`/album/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  getSetId(userId,id) {
    return http.get(`/set/${userId}/${id}`);
  }
  getTasksToBeEdited(userId,id) {
    return http.get(`/set/edit/${userId}/${id}`);
  }
  getAll(page,limit) {
    return http.get(`/album?page=${page}&limit=${limit}`);
  }
  getAllCombo(page,limit) {
    return http.get(`/album/combo?page=${page}&limit=${limit}`);
  }
  getAllNonCombo(page,limit) {
    return http.get(`/album/noncombo?page=${page}&limit=${limit}`);
  }
  delete(id, token) {
    return http.delete(`/album/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  update(id, data, token) {
    return http.put(`/album/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  getAlbumsByUserId(id, token) {
    return http.get(`/album/user/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  getRandomAlbumsByUserId(id, data) {
    return http.post(`/album/random/${id}`, data);
  }
  updateset(id, data) {
    return http.patch(`/set/${id}`, data);
  }
}
const albumService = new albumDataService();
export default albumService;
